<template>
  <el-container>
    <el-card shadow="always">
      <el-header>
        <el-card shadow="always" class="filtersCard">
          <el-row class="flex justify-center">
            <el-col :span="3">
              <el-tag class="Financiera"
                >Financiera ({{ FinancesData }})</el-tag
              >
            </el-col>
            <el-col :span="3">
              <el-tag class="DelCliente"
                >Del cliente ({{ FromClientData }})</el-tag
              >
            </el-col>
            <el-col :span="3">
              <el-tag class="ProcesosInternos"
                >Procesos internos ({{ InternalProccessData }})</el-tag
              >
            </el-col>
            <el-col :span="3">
              <el-tag class="DesarrolloYAprendizaje"
                >Desarrollo y aprendizaje ({{
                  LearningAndDevelopmentData
                }})</el-tag
              >
            </el-col>
            <el-col :offset="8" :span="2">
              <el-button
                type="success"
                icon="el-icon-plus"
                size="small"
                :disabled="loadingData"
                @click="openObjectiveDialog"
                >Crear Objetivo</el-button
              >
            </el-col>
            <el-col :offset="1" :span="1">
              <el-tooltip placement="top" effect="light">
                <div slot="content">
                  Recalcular Porcentaje de todos los objetivos
                </div>
                <el-button
                  type="primary"
                  icon="el-icon-refresh"
                  size="small"
                  :disabled="loadingData"
                  @click="recalculateAllObjectives"
                ></el-button>
              </el-tooltip>
            </el-col>
          </el-row>
        </el-card>
      </el-header>
      <el-main>
        <el-card shadow="always" class="filtersCard">
          <el-row class="filtersRow">
            <el-col :span="2" class="offset">
              <el-tooltip placement="top" effect="light">
                <div slot="content">Año</div>
                <YearsComponent
                  @change="onYearChange"
                  :disabled="loadingData"
                />
              </el-tooltip>
            </el-col>
            <el-col :span="2" class="offset">
              <el-tooltip placement="top" effect="light">
                <div slot="content">Mes</div>
                <MonthsComponent
                  :initial="actualMonth"
                  @change="onMonthChange"
                  :isDisabled="loadingData"
                />
              </el-tooltip>
            </el-col>
            <el-col :span="2" class="offset">
              <el-tooltip placement="top" effect="light">
                <div slot="content">Pendiente / Completado</div>
                <PendingCompletedTasksFilter
                  @PendingFilterChange="onPendingFilterChange"
                />
              </el-tooltip>
            </el-col>
            <el-col :span="2" class="offset">
              <el-tooltip placement="top" effect="light">
                <div slot="content">Tipo Estratégico</div>
                <TypeStrategicFilter
                  @TypeStrategicFilterChange="onTypeStrategicFilterChange"
                />
              </el-tooltip>
            </el-col>
            <el-col :span="2" class="offset">
              <el-tooltip placement="top" effect="light">
                <div slot="content">Perspectiva</div>
                <PerspectiveSelectorFilter
                  @PerspectiveSelectorFilterChange="
                    onPerspectiveSelectorFilterChange
                  "
                />
              </el-tooltip>
            </el-col>
            <el-col :span="3" class="offset">
              <el-tooltip placement="top" effect="light">
                <div slot="content">Dirección</div>
                <DirectionSelector
                  :initialDirection="filters.Direction"
                  @selection-change="OnDirectionSelected"
                  :isDisabled="loadingData"
                />
              </el-tooltip>
            </el-col>
            <el-col :span="3" class="offset">
              <el-tooltip placement="top" effect="light">
                <div slot="content">Departamento</div>
                <DepartmentsComponent
                  :initialDirection="filters.Direction ?? 0"
                  :initialDeparment="filters.Deparment"
                  :DirecctionID="filters.Direction"
                  fieldSize="mini"
                  @selectionChange="OnDeparmentSelected"
                  :isDisabled="loadingData"
                />
              </el-tooltip>
            </el-col>
            <el-col :span="3" class="offset">
              <el-tooltip placement="top" effect="light">
                <div slot="content">Responsable de objetivo</div>
                <EmployeeSelector
                  :DireccionParams="filters.Direction"
                  :DeparmentParams="filters.Deparment"
                  :CurrentEmployee="filters.Responsible"
                  placeholder="Resp. Objetivo"
                  @selection-change="OnResponsibleSelected"
                  :disabled="loadingData"
                />
              </el-tooltip>
            </el-col>
            <el-col :span="3" class="offset">
              <el-tooltip placement="top" effect="light">
                <div slot="content">Responsable de tarea</div>
                <EmployeeSelector
                  :DireccionParams="filters.Direction"
                  :DeparmentParams="filters.Deparment"
                  :CurrentEmployee="filters.ResponsibleTask"
                  placeholder="Resp. Tarea"
                  @selection-change="OnResponsibleTaskSelected"
                  :disabled="loadingData"
                />
              </el-tooltip>
            </el-col>
          </el-row>
        </el-card>
        <el-row class="reportContent">
          <rabbey-table-3
            v-if="
              this.filters.Responsible === this.currentUser.EmployeeId ||
              AmIsupervisor
            "
            :border="true"
            :stripe="true"
            :actions="objectivesActions"
            @rtable-push-action="handlePushAction"
            :loading="loadingData"
            :data="objectivesData"
            :columns="objectivesColumns"
            show-summary
            :summary-method="getSummaries"
            sum-text="Tiempo Total"
          />
        </el-row>
      </el-main>
    </el-card>

    <!-- <ObjectiveFormDialog
      :ObjectivFormDialogVisibility="ObjectivFormDialogVisibility"
      @ObjectivFormDialogClosing="OnObjectivFormDialogClosing"
    /> -->
    <TaskFormDialog
      :key="2"
      :TaskFormVisible="ObjectiveCreationVisibility"
      :WhatsThisFormFor="WhatsTheFormFor"
      :ObjectiveRow="ObjectiveRow"
      @ObjectiveSaved="OnObjectiveSaved"
      @ClosingTaskFormDialog="OnObjectivFormDialogClosing"
    />

    <ObjectiveTasksDialog
      :ObjectiveTasksDialogVisibility="TasksVisivility"
      :ActualObjective="actualObjective"
      :TaskResponsibleSelected="filters.ResponsibleTask"
      :IsPendingFilter="filters.isPending"
      :columnTaskCodeFrom="columnTaskCodeFrom"
      :IsInCharged="isInCharged"
      @TaskSavedToObjective="OnObjectiveSaved"
      @ObjectiveTasksDialogClosing="OnTasksDialogClose"
    />
  </el-container>
</template>

<script>
import {
  ObjectivesReportColumns,
  ObjectiveReportActions
} from "@/columns/ObjectivesReport/ObjectivesReportColumns";
import YearsComponent from "@/components/Global_System/YearsComponent";
import MonthsComponent from "@/components/Global_System/MonthsComponent";
import PendingCompletedTasksFilter from "@/components/cmi/ObjectivesReport/PendingCompletedTasksFilter";
import TypeStrategicFilter from "@/components/cmi/ObjectivesReport/TypeStrategicFilter";
import PerspectiveSelectorFilter from "@/components/cmi/ObjectivesReport/PerspectiveSelectorFilter";
import DirectionSelector from "@/components/Company/DirectionSelector";
import DepartmentsComponent from "@/components/Company/DepartmentsComponent";
import EmployeeSelector from "@/components/Company/EmployeeSelector";
// import ObjectiveFormDialog from "@/components/cmi/ObjectivesReport/ObjectiveFormDialog";
import ObjectiveTasksDialog from "@/components/cmi/ObjectivesReport/ObjectiveTasksDialog";
import TaskFormDialog from "@/components/cmi/ObjectivesReport/TaskFormDialog";

const actualYear = new Date().getFullYear();
const actualMonth = new Date().getMonth() + 1;
export default {
  name: "ObjectivesReport",

  components: {
    // Register any components needed for the report
    YearsComponent,
    MonthsComponent,
    PendingCompletedTasksFilter,
    TypeStrategicFilter,
    PerspectiveSelectorFilter,
    DirectionSelector,
    DepartmentsComponent,
    EmployeeSelector,
    // ObjectiveFormDialog,
    ObjectiveTasksDialog,
    TaskFormDialog
  },
  props: {
    // Define any props needed for the report
    actualTab: {
      type: Number,
      default: 0, // Default to the report tab
      required: false
    }
  },
  data() {
    return {
      // Define any data properties needed for the report
      objectivesData: [],
      objectivesColumns: ObjectivesReportColumns(this),
      objectivesActions: ObjectiveReportActions(this),
      loadingData: false,
      filters: {
        Year: actualYear,
        Month: actualMonth,
        isPending: null,
        TypeStrategic: null,
        Perspective: null,
        Direction: null,
        Deparment: null,
        Responsible: null,
        ResponsibleTask: null
        // Add other filter properties as needed
      },
      actualMonth: 0,
      ObjectiveFormDialogVisibility: false,
      ObjectiveRow: {},
      TasksVisivility: false,
      actualObjective: {},
      WhatsTheFormFor: 0,
      columnTaskCodeFrom: "",
      isInCharged: false
    };
  },
  computed: {
    // Define any computed properties needed for the report
    AmIsupervisor() {
      return true;
    },
    FinancesData() {
      let count;
      count = this.objectivesData.filter((od) => od.PerpectiveID === 1).length;
      return count;
    },
    FromClientData() {
      let count;
      count = this.objectivesData.filter((od) => od.PerpectiveID === 2).length;
      return count;
    },
    InternalProccessData() {
      let count;
      count = this.objectivesData.filter((od) => od.PerpectiveID === 3).length;
      return count;
    },
    LearningAndDevelopmentData() {
      let count;
      count = this.objectivesData.filter((od) => od.PerpectiveID === 4).length;
      return count;
    },
    ObjectiveCreationVisibility() {
      return this.ObjectiveFormDialogVisibility;
    }
  },
  watch: {
    // Define any watchers needed for the report
    async actualTab(val) {
      if (val === 5) {
        // If the active tab is the report tab, fetch the data

        this.isInCharged = await this.IsHeinCharged();
        await this.GetObjectivesData();
      }
    }
  },
  // async beforeCreate() {
  //   await this.IsHeinCharged();
  // },
  // async created() {
  //   await this.IsHeinCharged();
  // },
  async mounted() {
    // This lifecycle hook can be used to fetch data or perform actions when the component is mounted

    const actualDate = new Date();
    this.actualMonth = actualDate.getMonth() + 1;

    this.isInCharged = await this.IsHeinCharged();
    await this.GetObjectivesData();
    // (this.filters.Direction = this.currentUser.DireccionID),
    //   (this.filters.Deparment = this.currentUser.DepartamentID),
    //   (this.filters.Responsible = this.currentUser.EmployeeId);
    // await this.IsHeinCharged();
    // await this.GetObjectivesData();
  },
  methods: {
    // Define any methods needed for the report
    async GetObjectivesData() {
      this.loadingData = true;

      await this.$http
        .get("/api/CMI/Objetives/GetObjectivesGanttReport", {
          params: {
            Year: this.filters.Year,
            Month: this.filters.Month,
            isPending: this.filters.isPending,
            TypeStrategic: this.filters.TypeStrategic,
            Perspective: this.filters.Perspective,
            Direction: this.filters.Direction,
            Department: this.filters.Deparment,
            Responsible: this.filters.Responsible,
            TaskResponsible: this.filters.ResponsibleTask
          }
        })
        .then(async ({ data }) => {
          //await this.KnowIfIsHisSupervisor(data.CreatedBy)
          this.objectivesData = data;
          this.loadingData = false;
        });
    },
    async IsHeinCharged() {
      let IsHeinChargedPromise = await new Promise((resolve, reject) => {
        this.loadingData = true;
        const parameters = {
          params: {
            employee: this.currentUser.EmployeeId
          }
        };
        this.$http
          .get("/api/departments/IsHeIncharged", parameters)
          .then(({ data }) => {
            this.isInCharged = data;
            resolve(data);
          })
          .catch((err) => {
            this.$message.error(err);
            reject(err);
          });
      });
      return IsHeinChargedPromise;
    },
    handlePushAction(option) {
      const actualEmployee = this.currentUser.EmployeeId;
      const { row } = option;
      switch (option.command) {
        case "view_tasks": {
          this.columnTaskCodeFrom = "TT";
          this.actualObjective = row;
          this.TasksVisivility = true;
          break;
        }
        case "create_tasks": {
          this.WhatsTheFormFor = 0;
          this.ObjectiveRow = row;
          this.ObjectiveFormDialogVisibility = true;
          break;
        }
        case "edit_objective": {
          if (
            row.ResponsableId !== this.currentUser.EmployeeId ||
            this.currentUser.EmployeeId === 37
          ) {
            if (this.isInCharged) {
              this.WhatsTheFormFor = 3;
              this.ObjectiveRow = row;
              this.ObjectiveFormDialogVisibility = true;
            } else {
              this.$message({
                type: "error",
                message:
                  "No es encargado o gerente, por lo que no puede realizar esta acción"
              });
            }
            // WhatsTheFormFor 3 para edicion de objetivos
          } else {
            this.$message({
              type: "error",
              message:
                "Usted es el responsable de este objetivo, por lo que no puede realizar esta acción"
            });
          }
          break;
        }
        case "delete_objective": {
          if (
            row.ResponsableId !== this.currentUser.EmployeeId ||
            this.currentUser.EmployeeId === 37
          ) {
            if (this.isInCharged) {
              this.$confirm(
                "Seguro que desea continuar con el borrado de este objetivo?",
                row.CombinedTaskId,
                {
                  confirmButtonText: "Si",
                  cancelButtonText: "No",
                  type: "warning"
                }
              )
                .then(() => {
                  this.deleteObjective(row.ObjectiveCombinedId, actualEmployee);
                })
                .catch(() => {
                  this.$message({
                    type: "info",
                    message: "Operacion Cancelada"
                  });
                });
            } else {
              this.$message({
                type: "error",
                message:
                  "No es encargado o gerente, por lo que no puede realizar esta acción"
              });
            }
          } else {
            this.$message({
              type: "error",
              message:
                "Usted es el responsable de este objetivo, por lo que no puede realizar esta acción"
            });
          }
          break;
        }

        case "update_objective_percentage": {
          this.updateObjectivePercentage(row);

          break;
        }
        default: {
          break;
        }
      }
    },
    updateObjectivePercentage(row) {
      this.$confirm(
        "Seguro que desea continuar con la actualizacion del porcentaje de este objetivo?",
        row.CombinedTaskId,
        {
          confirmButtonText: "Si",
          cancelButtonText: "No",
          type: "warning"
        }
      )
        .then(() => {
          this.$http
            .post(`/api/CMI/Objetives/UpdateOjectivePercentage`, {
              ObjectiveId: row.ObjectiveId
            })
            .then(async (resp) => {
              if (resp.data > 0) {
                await this.GetObjectivesData();
                this.$message.success("Porcentaje actualizado con exito");
              } else {
                this.$message.error(
                  "Error al actualizar el porcentaje, intente nuevamente"
                );
              }
            })
            .catch((err) => {
              this.$message.error(err);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Operacion Cancelada"
          });
        });
    },

    async deleteObjective(objectiveId, actualEmployee) {
      await this.$http
        .post(
          `/api/CMI/Objetives/deleteGantt?id=${objectiveId}&employeeId=${actualEmployee}`
        )
        .then(async () => {
          await this.GetObjectivesData();
          this.$message.success("Objetivo eliminado con exito");
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    async onYearChange(year) {
      this.actualMonth = 1;
      this.filters.Year = year;
      await this.GetObjectivesData();
    },
    async onMonthChange(month) {
      month === 0 ? (this.filters.Month = null) : (this.filters.Month = month);
      await this.GetObjectivesData();
    },
    onPendingFilterChange(value) {
      value === 0
        ? (this.filters.isPending = null)
        : (this.filters.isPending = value);
      this.GetObjectivesData();
    },
    onTypeStrategicFilterChange(value) {
      value === 0
        ? (this.filters.TypeStrategic = null)
        : (this.filters.TypeStrategic = value);
      this.GetObjectivesData();
    },
    onPerspectiveSelectorFilterChange(value) {
      value === 0
        ? (this.filters.Perspective = null)
        : (this.filters.Perspective = value);
      this.GetObjectivesData();
    },
    OnDirectionSelected(val) {
      val === 0
        ? (this.filters.Direction = null)
        : (this.filters.Direction = val);
      this.GetObjectivesData();
    },
    OnDeparmentSelected(val) {
      val === 0
        ? (this.filters.Deparment = null)
        : (this.filters.Deparment = val);
      this.GetObjectivesData();
    },
    async OnResponsibleSelected(val) {
      val === 0
        ? (this.filters.Responsible = null)
        : (this.filters.Responsible = val);
      // await this.KnowIfIsHisSupervisor(val);
      this.GetObjectivesData();
    },
    async OnResponsibleTaskSelected(val) {
      val === 0
        ? (this.filters.ResponsibleTask = null)
        : (this.filters.ResponsibleTask = val);
      // await this.KnowIfIsHisSupervisor(val);
      this.GetObjectivesData();
    },
    async KnowIfIsHisSupervisor(responsible) {
      this.AmIsupervisor = false;
      await this.$http
        .get("/api/ReporteGestion/IsHisSupervisor", {
          params: {
            responsibleID: responsible,
            currentUserEmpId: this.currentUser.EmployeeId
          }
        })
        .then((response) => {
          this.AmIsupervisor = response.data;
        });
    },
    openObjectiveDialog() {
      // WhatsTheFormFor 0 crear tareas, 1 editar tareas, 2 crear objetivos, 3 editar objetivos
      this.WhatsTheFormFor = 2;
      this.ObjectiveFormDialogVisibility = true;
    },
    recalculateAllObjectives() {
      let row = {
        CombinedTaskId: "Todos los objetivos",
        ObjectiveId: 0
      };
      this.updateObjectivePercentage(row);
      this.GetObjectivesData();
    },
    OnObjectivFormDialogClosing(val) {
      this.ObjectiveFormDialogVisibility = val;
    },
    OnObjectiveSaved() {
      this.GetObjectivesData();
      this.ObjectiveFormDialogVisibility = false;
    },
    OnTasksDialogClose() {
      this.TasksVisivility = false;
    },
    OpenTasks(taskCode, row) {
      /*
          Codigos para diferencias los detalles de tareas segun la columna (@TaskCode)
            * TT - Total de Tareas
            * TR - Tareas Realizadas
            * TRTR - Tareas Retrasadas
            * TCSAnt - Tareas Cerradas Semana Anterior
            * TCSAct - Tareas Cerradas Semana Actual
            * TP - Tareas pendientes en progreso
            * TSA - Tareas Semana Actual
            * TSP - Tareas senmana proxima
            * TSPM1 - Tareas senmana proxima + 1
            * TSPM1 - Tareas senmana proxima + 2
      */

      this.columnTaskCodeFrom = taskCode;
      this.actualObjective = row;
      this.TasksVisivility = true;
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "Totales";
          return;
        }

        if (column.property === "TasksCount") {
          const values = data.map((item) => Number(item[column.property]));
          const totalHours = data.map((item) => Number(item.TotalHours));

          if (
            !values.every((value) => isNaN(value)) &&
            !totalHours.every((value) => isNaN(value))
          ) {
            sums[index] =
              "" +
              values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0) +
              " / " +
              totalHours.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  let sum = Number(prev + curr);
                  return sum;
                } else {
                  return Number(prev);
                }
              }, 0) +
              " h";
          } else {
            sums[index] = "";
          }
        } else if (column.property === "DoneTasksCount") {
          const values = data.map((item) => Number(item[column.property]));
          const doneTaskHours = data.map((item) => Number(item.DoneTaskHours));

          if (
            !values.every((value) => isNaN(value)) &&
            !doneTaskHours.every((value) => isNaN(value))
          ) {
            sums[index] =
              "" +
              values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0) +
              " / " +
              doneTaskHours.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  let sum = Number(prev + curr);
                  return sum;
                } else {
                  return Number(prev);
                }
              }, 0) +
              " h";
          } else {
            sums[index] = "";
          }
        } else if (column.property === "DelayedTasksCount") {
          const values = data.map((item) => Number(item[column.property]));
          const delayedTasksHours = data.map((item) =>
            Number(item.DelayedTasksHours)
          );

          if (
            !values.every((value) => isNaN(value)) &&
            !delayedTasksHours.every((value) => isNaN(value))
          ) {
            sums[index] =
              "" +
              values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0) +
              " / " +
              delayedTasksHours.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  let sum = Number(prev + curr);
                  return sum;
                } else {
                  return Number(prev);
                }
              }, 0) +
              " h";
          } else {
            sums[index] = "";
          }
        } else if (column.property === "ActualWeekClosedTasksCount") {
          const values = data.map((item) => Number(item[column.property]));
          const actualWeekClosedTasksHours = data.map((item) =>
            Number(item.ActualWeekClosedTasksHours)
          );

          if (
            !values.every((value) => isNaN(value)) &&
            !actualWeekClosedTasksHours.every((value) => isNaN(value))
          ) {
            sums[index] =
              "" +
              values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0) +
              " / " +
              actualWeekClosedTasksHours.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  let sum = Number(prev + curr);
                  return sum;
                } else {
                  return Number(prev);
                }
              }, 0) +
              " h";
          } else {
            sums[index] = "";
          }
        } else if (column.property === "WeekBeforeClosedTasksCount") {
          const values = data.map((item) => Number(item[column.property]));
          const weekBeforeClosedTasksHours = data.map((item) =>
            Number(item.WeekBeforeClosedTasksHours)
          );

          if (
            !values.every((value) => isNaN(value)) &&
            !weekBeforeClosedTasksHours.every((value) => isNaN(value))
          ) {
            sums[index] =
              "" +
              values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0) +
              " / " +
              weekBeforeClosedTasksHours.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  let sum = Number(prev + curr);
                  return sum;
                } else {
                  return Number(prev);
                }
              }, 0) +
              " h";
          } else {
            sums[index] = "";
          }
        } else if (column.property === "InProgressTasksCount") {
          const values = data.map((item) => Number(item[column.property]));
          const inProgressTasksHours = data.map((item) =>
            Number(item.InProgressTasksHours)
          );

          if (
            !values.every((value) => isNaN(value)) &&
            !inProgressTasksHours.every((value) => isNaN(value))
          ) {
            sums[index] =
              "" +
              values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0) +
              " / " +
              inProgressTasksHours.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  let sum = Number(prev + curr);
                  return sum;
                } else {
                  return Number(prev);
                }
              }, 0) +
              " h";
          } else {
            sums[index] = "";
          }
        } else if (column.property === "ActualWeekTasksCount") {
          const values = data.map((item) => Number(item[column.property]));
          const actualWeekTasksHours = data.map((item) =>
            Number(item.ActualWeekTasksHours)
          );

          if (
            !values.every((value) => isNaN(value)) &&
            !actualWeekTasksHours.every((value) => isNaN(value))
          ) {
            sums[index] =
              "" +
              values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0) +
              " / " +
              actualWeekTasksHours.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  let sum = Number(prev + curr);
                  return sum;
                } else {
                  return Number(prev);
                }
              }, 0) +
              " h";
          } else {
            sums[index] = "";
          }
        } else if (column.property === "WeekAfterTasksCount") {
          const values = data.map((item) => Number(item[column.property]));
          const weekAfterTasksHours = data.map((item) =>
            Number(item.WeekAfterTasksHours)
          );

          if (
            !values.every((value) => isNaN(value)) &&
            !weekAfterTasksHours.every((value) => isNaN(value))
          ) {
            sums[index] =
              "" +
              values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0) +
              " / " +
              weekAfterTasksHours.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  let sum = Number(prev + curr);
                  return sum;
                } else {
                  return Number(prev);
                }
              }, 0) +
              " h";
          } else {
            sums[index] = "";
          }
        } else if (column.property === "WeekAfterMas1TasksCount") {
          const values = data.map((item) => Number(item[column.property]));
          const weekAfterMas1TasksHours = data.map((item) =>
            Number(item.WeekAfterMas1TasksHours)
          );

          if (
            !values.every((value) => isNaN(value)) &&
            !weekAfterMas1TasksHours.every((value) => isNaN(value))
          ) {
            sums[index] =
              "" +
              values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0) +
              " / " +
              weekAfterMas1TasksHours.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  let sum = Number(prev + curr);
                  return sum;
                } else {
                  return Number(prev);
                }
              }, 0) +
              " h";
          } else {
            sums[index] = "";
          }
        } else if (column.property === "WeekAfterMas2TasksCount") {
          const values = data.map((item) => Number(item[column.property]));

          const weekAfterMas2TasksHours = data.map((item) =>
            Number(item.WeekAfterMas2TasksHours)
          );

          if (
            !values.every((value) => isNaN(value)) &&
            !weekAfterMas2TasksHours.every((value) => isNaN(value))
          ) {
            sums[index] =
              "" +
              values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0) +
              " / " +
              weekAfterMas2TasksHours.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  let sum = Number(prev + curr);
                  return sum;
                } else {
                  return Number(prev);
                }
              }, 0) +
              " h";
          } else {
            sums[index] = "";
          }
        } else {
          const values = data.map((item) => Number(item[column.property]));

          if (!values.every((value) => isNaN(value))) {
            sums[index] =
              "" +
              values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
          } else {
            sums[index] = "";
          }
        }
      });
      return sums;
    }
  }
};
</script>

<style lang="scss" scoped>
.filtersRow {
  /* padding-bottom: 1rem; */
  padding-top: 1rem;
}
.filtersCard {
  padding-bottom: 1rem;
  margin-bottom: 0%;
}

.Financiera {
  background-color: rgba(168, 211, 240, 0.6); /* light purple */
  color: blue; /* texto morado más oscuro para contraste */
  border-color: blue; /* borde más suave */
}
.DelCliente {
  background-color: rgba(195, 240, 168, 0.6); /* light purple */
  color: green; /* texto morado más oscuro para contraste */
  border-color: green;
}
.ProcesosInternos {
  background-color: rgba(240, 234, 168, 0.6); /* light purple */
  color: darkgoldenrod; /* texto morado más oscuro para contraste */
  border-color: darkgoldenrod;
}
.DesarrolloYAprendizaje {
  background-color: rgba(220, 168, 240, 0.6); /* light purple */
  color: purple; /* texto morado más oscuro para contraste */
  border-color: purple;
}
.movingToLeft {
  position: absolute;
  right: 1rem;
}

.offset {
  margin-left: 0.5rem;
}
</style>
